export const GET_ALL_LISTINGS = 'GET_ALL_LISTINGS';
